/**
 * 受講生のコース詳細画面（student/course.blade.php）
 * - 学習時間のプログレスバーの幅を設定する
 * - 未受験のテストを開始する前に確認ダイアログを表示する（成績考査とそれ以外で文言を分ける）
 */
const GRADE_EXAMINATION_CONFIRM_MESSAGE = '「成績考査」は1度しか受けられません。1度テストのページにアクセスしたら、答えを必ず送信してください。\n'
    + '解答せずにページのリロードや戻る、他のページに遷移すると無回答（0点）扱いになり、結果も不合格となります。\n'
    + 'また、本テストは必ず60分以上の時間をかける必要があります。日を跨いで受験されるとログが切れてしまうため、受験時間にご留意下さい。\n'
    + '（23:59と0:00でログが分かれ、最初のログのみがカウントされます）\n'
    + '※お使いのPCの充電が途中で切れるなどのトラブルが生じた場合も同様ですので、テストを開始する前にご自身の環境を十分にご確認ください。';

const PROFICIENCY_EXAMINATION_CONFIRM_MESSAGE = '「習熟度確認テスト」は1度しか受けられません。1度テストのページにアクセスしたら、答えを必ず送信してください。\n'
    + '解答せずにページのリロードや戻る、他のページに遷移すると無回答（0点）扱いになり、結果も不合格となります。\n'
    + '※ 習熟度確認テストは 3回連続で不合格になると退校処分となりますのでご注意ください。\n'
    + '※お使いのPCの充電が途中で切れるなどのトラブルが生じた場合も同様ですので、テストを開始する前にご自身の環境を十分にご確認ください。';

const initProgressBar = () => {
    // app.js から全画面で読み込まれるため、同じ id を持つ動画画面のバー（data-width なし）は対象外にする
    const progressBar = document.querySelector('#progress_bar[data-width]');
    if (!progressBar) {
        return;
    }
    progressBar.style.width = `${progressBar.dataset.width}%`;
};

const initExaminationStartConfirm = () => {
    document.querySelectorAll('[data-examination-start-confirm]').forEach((button) => {
        button.addEventListener('click', (e) => {
            const message = button.dataset.examinationStartConfirm === 'grade'
                ? GRADE_EXAMINATION_CONFIRM_MESSAGE
                : PROFICIENCY_EXAMINATION_CONFIRM_MESSAGE;
            // キャンセル時は親の <a> によるテスト画面への遷移を止める
            if (!confirm(message)) {
                e.preventDefault();
            }
        });
    });
};

const initStudentCourseShow = () => {
    initProgressBar();
    initExaminationStartConfirm();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStudentCourseShow);
} else {
    initStudentCourseShow();
}
